import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import HelpModal from '../HelpModal/HelpModal';
import { HeaderContainer } from './Header.styles';

const Header = () => {
    const [showHelp, setShowHelp] = useState(false);
    const location = useLocation();

    return (
        <HeaderContainer>
            {location.pathname !== '/ys.html' &&
                <Link to="/?go=main" className="backBtn">
                    <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                        <path d="M13 4L7 10L13 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </Link>
            }
            <div className={`headerTitle ${location.pathname === '/ys.html' ? 'ysTitle' : ''}`}>
                {location.pathname === '/ys.html' ? '110기 첫 엠티' : 'MICRO WEATHER'}
            </div>
            <button className="helpBtn" onClick={() => setShowHelp(true)}>?</button>

            {showHelp &&
                <HelpModal
                    page={location.pathname}
                    onClose={() => setShowHelp(false)}
                />
            }
        </HeaderContainer>
    );
};

export default Header;
